import { useCallback } from "react";

import { userFields } from "kw/api/fragments";
import { useAPI } from "kw/api/useAPI";

export function useSsoVerification(authenticatorType) {
  const { mutation, loading } = useAPI();

  const verifySsoUser = useCallback(
    (callback) => {
      mutation(
        {
          ssoVerification: [
            {
              authenticatorType: authenticatorType,
              // credential: credential,
            },
            {
              token: true,
              user: userFields,
            },
          ],
        },
        async (response) => callback(response)
      );
    },
    [authenticatorType]
  );

  return { verifySsoUser, loading };
}
